import React from 'react';
import PageHero from './componenets/PageHero';
import Reveal from './componenets/Reveal';

export const BurialPlot = () => (
  <div className="site-page">
    <PageHero eyebrow="Burial plots" title="Burial Plot Pledge Form" description="Submit your information securely using the form below." image="/images/HomeSlider11.jpg" compact />
    <section className="site-section site-section--sage"><Reveal className="site-container embed-card"><iframe title="Burial Plot Pledge Form" src="https://docs.google.com/forms/d/e/1FAIpQLSdlV6u4lgfYjNRdYN8ehwNiO1oM1u0ksTde4ZVmAuw7XE2CPg/viewform?embedded=true">Loading…</iframe></Reveal></section>
  </div>
);
